<template>
    <main v-html="$store.getters.getContentData.webpage_content"></main>
</template>

<script>
export default {
    name: "Index",
    beforeRouteEnter(to, from, next) {
        document.title = to.meta.title;
        next(async (vm) => {
            await vm.$store.dispatch("fetchMenu", {
                lang: to.params.lang,
            });
            await vm.$store.dispatch("fetchKv", {
                content: "index",
                lang: to.params.lang,
            });
            await vm.$store.dispatch("fetchContent", {
                content: "index",
                lang: to.params.lang,
            });
        });
    },
    async beforeRouteUpdate(to, from, next) {
        // document.title = to.meta.title;
        await this.$store.dispatch("fetchMenu", {
            lang: to.params.lang,
        });
        await this.$store.dispatch("fetchKv", {
            content: "index",
            lang: to.params.lang,
        });
        await this.$store.dispatch("fetchContent", {
            content: "index",
            lang: to.params.lang,
        });
        next();
    },
};
</script>

<style lang="sass" scoped></style>
